import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
export default {
  name: "mycontractdetail",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      base64Str: ""
    });
    onMounted(() => {
      handleCustomerContractInfo();
    });
    const handleCustomerContractInfo = async () => {
      const {
        contractId
      } = route.query;
      var base64Str = await globalProperties.$api.customerContractInfo(contractId);
      data.base64Str = base64Str;
    };
    return {
      mainStore,
      data
    };
  }
};